import axios from 'axios';
//import { MasterCityModel, MasterStateModel } from '../type';
import './axios-interceptor';

export default {
  async getStates() {
    return await axios.get(`geo/states`);
  },

  async getCityByState(state: string) {
    return await axios.get(`geo/cities/${state}`);
  },
};
